import React from 'react';
import Head from 'next/head';
import StaticContentView from '@common/views/StaticContentView';
import YourPrivacyRightsInfo from '@components/YourPrivacyRightsInfo';

const pageTitle = 'ResortPass | Your Privacy Rights';

export default function YourPrivacyRights() {
  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta property="og:title" content={pageTitle} key="title" />
        <meta
          name="description"
          content="Understand your privacy rights with ResortPass. Get detailed information on data collection, usage, and protection, and learn how to manage your personal data preferences."
        />
      </Head>

      <StaticContentView>
        <YourPrivacyRightsInfo />
      </StaticContentView>
    </>
  );
}
